export default "__VITE_ASSET__5938b3f2__"